module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.crmData.name),
      expression: "crmData.name"
    }],
    attrs: {
      "type": "hidden",
      "id": "crm-hidden-name"
    },
    domProps: {
      "value": (_vm.crmData.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.crmData, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.crmData.account),
      expression: "crmData.account"
    }],
    attrs: {
      "type": "hidden",
      "id": "crm-hidden-account"
    },
    domProps: {
      "value": (_vm.crmData.account)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.crmData, "account", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.crmData.phone),
      expression: "crmData.phone"
    }],
    attrs: {
      "type": "hidden",
      "id": "crm-hidden-phone"
    },
    domProps: {
      "value": (_vm.crmData.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.crmData, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.crmData.email),
      expression: "crmData.email"
    }],
    attrs: {
      "type": "hidden",
      "id": "crm-hidden-email"
    },
    domProps: {
      "value": (_vm.crmData.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.crmData, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.crmData.subject),
      expression: "crmData.subject"
    }],
    attrs: {
      "type": "hidden",
      "id": "crm-hidden-subject"
    },
    domProps: {
      "value": (_vm.crmData.subject)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.crmData, "subject", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.crmData.symptoms),
      expression: "crmData.symptoms"
    }],
    attrs: {
      "type": "hidden",
      "id": "crm-hidden-symptoms"
    },
    domProps: {
      "value": (_vm.crmData.symptoms)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.crmData, "symptoms", $event.target.value)
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57f7fea2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile-page/impl/delete-account/imlp/data-for-crm/index.vue
// module id = 414
// module chunks = 1